var Backbone, SupportLegacyOrderBannerTemplate, SupportLegacyOrderBannerView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportLegacyOrderBannerTemplate = require('../../legacy_order_banner.html.mustache');

SupportLegacyOrderBannerView = (function(superClass) {
  extend(SupportLegacyOrderBannerView, superClass);

  function SupportLegacyOrderBannerView() {
    return SupportLegacyOrderBannerView.__super__.constructor.apply(this, arguments);
  }

  SupportLegacyOrderBannerView.prototype.className = 'legacy-order-banner';

  SupportLegacyOrderBannerView.prototype.initialize = function() {
    var ref;
    this.legacyOrderLinkEligible = window.brand === "livingsocial";
    if (this.legacyOrderLinkEligible) {
      this.legacyOrderMessage = this.getLegacyOrderMessage((ref = window.currentUser) != null ? ref.id : void 0);
    }
    return this.template = SupportLegacyOrderBannerTemplate;
  };

  SupportLegacyOrderBannerView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportLegacyOrderBannerView.prototype.toHash = function() {
    return {
      legacyOrderLinkEligible: this.legacyOrderLinkEligible,
      legacyOrderMessage: this.legacyOrderMessage
    };
  };

  SupportLegacyOrderBannerView.prototype.getLegacyOrderMessage = function(userId) {
    return _.unescape(I18n.translate('js.modules.support.legacy_order_message', {
      user_id: userId
    }));
  };

  return SupportLegacyOrderBannerView;

})(Backbone.View);

module.exports = SupportLegacyOrderBannerView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvbGVnYWN5X29yZGVyX2Jhbm5lcl92aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL2xlZ2FjeV9vcmRlcl9iYW5uZXJfdmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSx3RUFBQTtFQUFBOzs7QUFBQSxRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBQ1gsUUFBUSxDQUFDLENBQVQsR0FBYTs7QUFDYixnQ0FBQSxHQUFtQyxPQUFBLENBQVEseUNBQVI7O0FBRTdCOzs7Ozs7O3lDQUNKLFNBQUEsR0FBVzs7eUNBRVgsVUFBQSxHQUFZLFNBQUE7QUFDVixRQUFBO0lBQUEsSUFBQyxDQUFBLHVCQUFELEdBQTJCLE1BQU0sQ0FBQyxLQUFQLEtBQWdCO0lBQzNDLElBQXdFLElBQUMsQ0FBQSx1QkFBekU7TUFBQSxJQUFDLENBQUEsa0JBQUQsR0FBc0IsSUFBQyxDQUFBLHFCQUFELHlDQUF5QyxDQUFFLFdBQTNDLEVBQXRCOztXQUNBLElBQUMsQ0FBQSxRQUFELEdBQVk7RUFIRjs7eUNBS1osTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUFsQixFQUE2QixJQUFDLENBQUEsU0FBOUIsQ0FBWjtFQURNOzt5Q0FHUixNQUFBLEdBQVEsU0FBQTtXQUNOO01BQUEsdUJBQUEsRUFBeUIsSUFBQyxDQUFBLHVCQUExQjtNQUNBLGtCQUFBLEVBQW9CLElBQUMsQ0FBQSxrQkFEckI7O0VBRE07O3lDQUlSLHFCQUFBLEdBQXVCLFNBQUMsTUFBRDtXQUNyQixDQUFDLENBQUMsUUFBRixDQUFXLElBQUksQ0FBQyxTQUFMLENBQWUseUNBQWYsRUFBMEQ7TUFBQyxPQUFBLEVBQVMsTUFBVjtLQUExRCxDQUFYO0VBRHFCOzs7O0dBZmtCLFFBQVEsQ0FBQzs7QUFrQnBELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
